import { Spinner } from "react-bootstrap";

export default function LoadingCentered({show}) {
  if (show) {
    return (
      <div className="loading-centered">
        <Spinner animation="border" role="status" variant="primary" />
      </div>
    );
  } else {
    return (<></>);
  }
}